import { useCallback, useState } from 'react';
import { DEFAULT_TABLE_LIMIT_FOR_CHECKBOX_TABLE } from '../checkbox-table/utils';
export function useTableRowLimit({
  onChangeRowLimitCallback,
  defaultRowLimit = DEFAULT_TABLE_LIMIT_FOR_CHECKBOX_TABLE
} = {}) {
  const [rowLimit, setRowLimit] = useState(defaultRowLimit);
  const onRowLimitChange = useCallback(({
    target: {
      value
    }
  }) => {
    setRowLimit(Number(value));
    onChangeRowLimitCallback === null || onChangeRowLimitCallback === void 0 || onChangeRowLimitCallback(Number(value));
  }, [onChangeRowLimitCallback]);
  return {
    rowLimit,
    onRowLimitChange
  };
}